import { ShareStatus } from "@authory-packages/core";

/**
 * Whether a share status keeps a resource behind a link or a password rather than out in the open.
 * The public status differs per resource: `Published` for profiles, `SecureLinkOptionalPasswordProtected`
 * for content items and collections. `Unpublished` answers 404 before a gate is reached, so it never gets here.
 * @param shareStatus The share status of the profile, collection or item
 * @param publicStatus The share status that means public for this resource
 * @returns True when the resource must not be indexed
 */
export function isGatedShareStatus(shareStatus: ShareStatus | undefined, publicStatus: ShareStatus) {
    return !!shareStatus && shareStatus !== publicStatus;
}
